export function handleError(error) {
    console.log(error);
    if (!error || !error.response) {
        if (error && error.code === 'ECONNABORTED') return 'timeout';
        return 'networkError';
    }
    if (error.response.status == 401) return 'unauthorized';
    if (error.response.status == 429) return 'tooManyRequest';
    return 'internalError';
}

// Laravel paginator or plain array -> { list, lastPage }
export function pickList(data, key) {
    let node = data || {};
    if (key && node[key] !== undefined) node = node[key];
    if (Array.isArray(node)) return { list: node, lastPage: 1 };
    return {
        list: Array.isArray(node.data) ? node.data : [],
        lastPage: node.last_page || 1,
    };
}
